// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a7c62872","455":"30b2169b","977":"9adcd920"}[chunkId] + ".chunk.js";
};